import { gql } from '@apollo/client';

export default gql`
  query cancelHotelRefundProposal($reference: String!) {
    cancelHotelRefundProposal(reference: $reference) {
      hotelRooms {
        name
        currency
        refund
        penalty
        margin
      }
    }
  }
`;
